<ul class="property-block__list">
    <li class="property-block__list-item">
        <div class="property-block__label" id="phone">Preferred Phone</div>
        <div class="property-block__value" role="definition" aria-labelledby="phone">{{ phone }}</div>
    </li>
    <li class="property-block__list-item">
        <div class="property-block__label" id="altPhone">Alternate Phone</div>
        <div class="property-block__value" role="definition" aria-labelledby="altPhone">{{ alternatePhone }}</div>
    </li>
    <li class="property-block__list-item">
        <div class="property-block__label" id="fax">Fax</div>
        <div class="property-block__value" role="definition" aria-labelledby="fax">{{ fax }}</div>
    </li>
    <li class="property-block__list-item">
        <div class="property-block__label" id="email">Preferred Email Address</div>
        <div class="property-block__value" role="definition" aria-labelledby="email"><a href="mailto:{{ email }}">{{ email }}</a></div>
    </li>
    <li class="property-block__list-item">
        <div class="property-block__label" id="email">Alternate Email Address</div>
        <div class="property-block__value" role="definition" aria-labelledby="altEmail"><a href="mailto:{{ alternateEmail }}">{{ alternateEmail }}</a></div>
    </li>
</ul>
